module.exports = ".content-wrapper {\r\n  background: #ecf0f5;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/layout/layout.component.css
// module id = ./src/app/shared/components/layout/layout.component.css
// module chunks = main